import React from 'react';
import {useIntl} from 'react-intl';
import {DataItem} from '../../../_common/components/DataItem';
import styles from './styles.module.scss';

const CustomerInfo = () => {
  const intl = useIntl();
  const fieldCustomerNameLabel = intl.formatMessage({
    id: 'invoice-orders-popup-create-customer-customerName',
    defaultMessage: 'Customer name'
  });
  const fieldCustomerIDLabel = intl.formatMessage({
    id: 'invoice-orders-popup-create-customer-ID',
    defaultMessage: 'Customer ID'
  });
  const fieldIdNumberLabel = intl.formatMessage({
    id: 'invoice-orders-popup-create-customer-idNumber',
    defaultMessage: 'Id number'
  });
  const fieldCustomerPhoneNumber = intl.formatMessage({
    id: 'invoice-orders-popup-create-customer-phoneNumber',
    defaultMessage: 'Phone'
  });
  const fieldCustomerEmail = intl.formatMessage({
    id: 'invoice-orders-popup-create-customer-email',
    defaultMessage: 'Email'
  });
  const fieldCustomerAddress = intl.formatMessage({
    id: 'invoice-orders-popup-create-customer-address',
    defaultMessage: 'Address'
  });

  const customerInfo = [
    {key: 'customerID', label: fieldCustomerIDLabel},
    {key: 'customerName', label: fieldCustomerNameLabel},
    {key: 'idNumber', label: fieldIdNumberLabel},
    {key: 'phone', label: fieldCustomerPhoneNumber},
    {key: 'email', label: fieldCustomerEmail},
    {key: 'address', label: fieldCustomerAddress},
    {key: 'actions', label: ''}
  ];

  const commonInputProps = {
    topLabelStyle: 'custom-brand-color',
    disabled: true,
  };
  const unitCustomerInfo = (data) => {
    return data && data.map((item, index) => {
      if (index !== (customerInfo.length - 1)) {
        return (
          <div className={styles.field} key={index}>
            <DataItem
              fieldId={item.key}
              label={item.label}
              {...commonInputProps}
            />
          </div>
        );
      }
    });
  };

  return (
    <div className={styles.customerInfoContainer}>
      {unitCustomerInfo(customerInfo)}
    </div>
  );
};

export default CustomerInfo;
